import React from 'react';

const StepItem = ({children, stepNum, optional, title }) => {
	
	return (
		<div className="step-item column-container">
			<div className="step-header">
				<h3>{stepNum}</h3><h2>{title}</h2>
			</div>
			{children}
		</div>
	)
}

export default StepItem;